.jb-input-web-component{
    --jb-input-input-direction: var(--input-direction);
}
